import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { InfoBanner } from 'ui/banner';
import { spacing } from 'ui/theme';
import { useSnippetsContext } from '../context';

const BannerWrapper = styled.div`
  margin-bottom: ${spacing.plusHalf};
`;

export const SnippetsBanners = () => {
  const { startTime } = useSnippetsContext();
  const LaunchDate = new Date('Dec 1 2023').valueOf(); // TODO: Update placeholder time
  const [isDateBannerOpen, setIsDateBannerOpen] = useState(false);

  useEffect(() => {
    setIsDateBannerOpen(!!startTime && Date.parse(startTime).valueOf() < LaunchDate);
  }, [startTime]);

  return (
    <BannerWrapper>
      {isDateBannerOpen && (
        <InfoBanner
          onClose={() => {
            setIsDateBannerOpen(false);
          }}
        >
          Only information from Dec 1, 2023 onwards is available for Snippets.{' '}
          <b>See documentation for more details.</b>
        </InfoBanner>
      )}
    </BannerWrapper>
  );
};
